module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dimmable"
  }, [_c('div', {
    staticClass: "ui inverted dimmer transition",
    class: {
      'visible active': _vm.loading
    }
  }, [_c('div', {
    staticClass: "ui text loader"
  }, [_vm._v("Loading")])]), _vm._v(" "), _c('step-bar'), _vm._v(" "), _c('error-message', {
    attrs: {
      "message-list": _vm.errorMessage
    },
    on: {
      "clearMessageList": _vm.clearErrorMessage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('products-list', {
    attrs: {
      "products-list": _vm.productsList
    },
    on: {
      "removeSelectedProduct": _vm.removeSelectedProduct,
      "updateQuantity": _vm.updateQuantityOfSelectedProduct
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('form', {
    attrs: {
      "action": _vm.formActionUrl,
      "method": "POST"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "action",
      "value": "process"
    }
  }), _vm._v(" "), (!_vm.anyProductInCart) ? _c('empty-cart') : _vm._e(), _vm._v(" "), _c('comment', {
    attrs: {
      "in-cart": _vm.anyProductInCart,
      "content": _vm.comment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('total-price', {
    attrs: {
      "in-cart": _vm.anyProductInCart,
      "price": _vm.totalWithCurrency,
      "show-store-offer-control": _vm.isAE,
      "is-store-offer": _vm.isStoreOffer
    },
    on: {
      "storeOfferChanged": _vm.applyStoreOffer
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('button-collection', {
    attrs: {
      "in-cart": _vm.anyProductInCart,
      "default-url": _vm.defaultActionUrl
    },
    on: {
      "removeAllProducts": _vm.openMaskForcheckToRemoveAllProducts
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('mask-for-check-to-remove-all-products', {
    attrs: {
      "show": _vm.shouldCheckToRemoveAllProducts
    },
    on: {
      "confirm": _vm.confirmToRemoveAllProducts,
      "close": _vm.closeMaskForcheckToRemoveAllProducts
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-257bb9fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 375
// module chunks = 0